module.exports = __webpack_public_path__ + "static/media/SubwayLogo.b4d93382.svg";